<template>
  <div style="min-height:70vh;padding:20px">
    <!-- <Form :model="searchData" inline @submit.native.prevent="getData(1)" :label-width="100">
      <FormItem label="名称">
        <Input v-model="searchData.name" clearable/>
      </FormItem>
      <Button type="primary" icon="ios-search" html-type="submit">搜索</Button>
    </Form> -->
    <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border style="margin:10px 0;">
      <template slot-scope="{ row }" slot="ali_pic">
        <img v-if='row.ali_pic' style="width:20px;height:20px" @click="handleView(row.ali_pic)"
          :src="path + row.ali_pic" />
      </template>
      <template slot-scope="{ row }" slot="wx_pic">
        <img v-if='row.wx_pic' style="width:20px;height:20px" @click="handleView(row.wx_pic)"
          :src="path + row.wx_pic" />
      </template>
      <template slot-scope="{ row }" slot="type">
        {{ row.type == 1 ? '微信' : row.type == 2 ? '支付宝' : '银行卡' }}
      </template>
      <template slot-scope="{ row }" slot="status">
        {{ row.status == 1 ? '审核中' : row.status == 2 ? '审核通过' : '审核拒绝' }}
      </template>
    </Table>
    <Page style="text-align:right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
    <Modal title="查看大图" v-model="visible">
      <img :src="path + imgName" v-if="visible" style="width: 100%" />
      <div slot="footer">
        <Button type="text" size="small" @click="visible = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage";
  export default {
    data() {
      return {
        searchData: {
        },
        visible: false,
        imgName: "",
        tableColumns: [
          { title: "ID", key: "id", width: 80, align: "center" },
          { title: "到账金额", key: "money", align: "center", minWidth: 120, },
          // { title: "提现方式", slot: "type", align: "center"},
          { title: "手续费", key: "service_charge", align: "center", minWidth: 120, },
          { title: "提现积分数量", key: "remain_money", align: "center", minWidth: 120, },
          // { title: "支付宝账号", key: "alipay", align: "center" },
          // { title: "银行卡号", key:"bank_no", minWidth: 40, align: "center" },
          { title: "支付宝支付码", slot: "ali_pic", minWidth: 120, align: "center" },
          { title: "微信支付码", slot: "wx_pic", align: "center", minWidth: 120, },
          { title: "状态", slot: "status", align: "center", minWidth: 120, },
          // { title: "操作", slot: "action", align: "center"},
        ],
        indexUrl: "/app/withdraw/index",
      };
    },
    mixins: [indexPage],
    methods: {
      handleView(url) {
        this.imgName = url;
        this.visible = true;
      },
    }
  };
</script>
<style scoped>
  .group-name:nth-child(n + 2)::before {
    content: " / ";
  }
</style>
